export const DAY_GROUP = [
    {
        title: "일요일",
        id: "SUN",
        subTitle: "일",
    },
    {
        title: "월요일",
        id: "MON",
        subTitle: "월",
    },
    {
        title: "화요일",
        id: "TUS",
        subTitle: "화",
    },
    {
        title: "수요일",
        id: "WEN",
        subTitle: "수",
    },
    {
        title: "목요일",
        id: "THU",
        subTitle: "목",
    },
    {
        title: "금요일",
        id: "FRI",
        subTitle: "금",
    },
    {
        title: "토요일",
        id: "SAT",
        subTitle: "토",
    },
];
